import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  actionsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  menuIcon: {
    minWidth: '35px',
    color: theme.palette.text.secondary,
  },
}))

export default useStyles
